export default{
  setStudio: (state, payload) => {state.studio = payload},
  setSellingPoints: (state, payload) => {state.sellingPoints = payload},
  setSellingPoint: (state, payload) => {state.sellingPoint = payload},
  setOnlineShops: (state, payload) => {state.onlineShops = payload},
}